// extracted by mini-css-extract-plugin
export default {"container":"MainApproval_container__HW6RO","title":"MainApproval_title__OYH7Q","content":"MainApproval_content__vm63C"};